import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SEO from '../components/SEO';
import Header from '../components/Header';
import { IndustriesHero, IndustriesContent } from '../components/IndustriesPageSections';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const IndustriesPage = () => {
  return (
    <div className="min-h-screen bg-white text-securelec-dark">
      <SEO 
        title="Industries We Serve - Electrician Bayside Melbourne"
        description="Electrical and security services for residential, commercial, medical, retail, industrial and construction sectors in Carrum and Bayside Melbourne."
        keywords="commercial electrician Bayside, residential electrician Carrum, medical clinic electrician, retail security systems, industrial electrical Melbourne"
        canonical="https://securelec.net.au/industries"
      />
      <Header />
      <main>
        <IndustriesHero />
        <IndustriesContent />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default IndustriesPage;
